<template>
  <div class="welcome-screen-overlay center-middle">
    <div class="welcome-content">
      <div class="center-middle">
        <div class="d-block mt-5">
          <img
              width="200"
              height="auto"
              class="ml-5 mb-2"
              src="https://media.futalis.com/futalis/interface/Icon_Willkommenseite.svg"
              alt="pet welcome"
          />
          <h6 class="futalis-text-green text-uppercase mt-4">
            Herzlich Willkommen
          </h6>
        </div>
      </div>
      <div style="color: #343a40" class="center-middle mx-5 mt-3">
        <div class="d-block">
          <p class="mb-1">
            In den letzten Monaten haben wir viel optimiert, um Ihren Tierarzt-Bereich übersichtlicher zu gestalten.
          </p>
          <p>
            Haben Sie einen Moment? Wir zeigen Ihnen kurz die wichtigsten
            Neuerungen.
          </p>
        </div>
      </div>
      <div class="center-middle mt-3 mb-4">
        <button
          @click="$emit('userAction', false)"
          class="futalis-btn py-1 ml-2 cancel-button"
        >
          Ich versuch’s erstmal alleine
        </button>
        <button
          @click="$emit('userAction', true)"
          class="ml-5 py-1 mr-2 futalis-button-orange futalis-btn"
        >
          Los geht’s!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome'
};
</script>

<style scoped>
.welcome-screen-overlay {
  background-color: rgba(255, 250, 250, 0.91) !important;
  position: fixed;
  left: 0;
  top: -125px;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 125 !important;
  padding-top: 95px;
}

.welcome-content {
  border-radius: 5px;
  font-size: 15px;
  max-width: 740px;
  background-color: #ffffff;
  border: 3px solid #c3c3c3;
}

.cancel-button {
  background-color: #c3c3c3;
  color: #343a40;
}

.cancel-button:hover {
  background-color: #efefef;
  color: #505350;
}
</style>
